<template>
    <div :class="containerClass">
        <vue-headful v-if="showHeadful" :title="title"></vue-headful>
        <div class="justify-content-between card-title row m-0" v-if="showDescription">
            <div class="col-sm-12 col-md-6 m-0" :class="sizeClass" v-if="showTitle"><i v-if="icon" class="mr-3" :class="icon"></i>{{ title }}</div>
            <div class="col-sm-12 col-md-6 m-0 text-right" v-if="showDescription">
                <span :class="sizeClass">
                    {{description}}
                </span>
            </div>
        </div>
        <div class="card-title row m-0" v-else>
            <div class="m-0" :class="sizeClass" v-if="showTitle"><i v-if="icon" class="mr-3" :class="icon"></i>{{ title }}</div>
        </div>
    </div>
</template>

<script>
    import VueHeadful from 'vue-headful';

    export default {
        components: { VueHeadful },
        props: {
            title: String,
            showTitle: {
                type: Boolean,
                default: true
            },
            showDescription: {
                type: Boolean,
                default: false
            },
            description: String,
            icon: String,
            sizeClass: {
                type: String,
                default: 'h4'
            },
            containerClass: {
                type: String,
                default: ''
            },
            showHeadful: {
                type: Boolean,
                default: true
            },
        }
    }
</script>
